import { useDispatch, useSelector } from "react-redux";
import { login, logout } from "../redux/slices/authSlice";

export const useAuth = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, user, role } = useSelector((state) => state.auth);

  const loginUser = (userData, userRole = "User") => {
    dispatch(login({ user: userData, role: userRole }));
  };

  const logoutUser = () => {
    dispatch(logout());
  };

  const isAdmin = role?.toLowerCase() === "admin";

  return { isAuthenticated, user, role, isAdmin, loginUser, logoutUser };
};
